import { render, staticRenderFns } from "./ViewRecordOfAcheivement.vue?vue&type=template&id=00aa8b36&"
import script from "./ViewRecordOfAcheivement.vue?vue&type=script&lang=js&"
export * from "./ViewRecordOfAcheivement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports